import { AbstractControl, ValidatorFn } from '@angular/forms';
import { exactValidator } from '../shared/validators/registration-validators';

/**
 * Sets a form control validator as same value as another field
 * @param {AbstractControl} firstField
 * @param {AbstractControl} secondField
 * @param {ValidatorFn[]} previousValidators validators to preserve
 */
export function sameValueTwoFields(
  firstField: AbstractControl,
  secondField: AbstractControl,
  previousValidators: ValidatorFn[]
) {
  firstField.valueChanges.subscribe((value) => {
    secondField.clearValidators();
    secondField.setValidators([...previousValidators, exactValidator(value)]);
    secondField.updateValueAndValidity();
  });
}
